import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnnualPlanRow, AnnualPlanService } from '../../providers/annual-plans.services';
import { AnnualPlanFormComponent } from '../../components/form/annual-plan-form.component';
import { AnnualPlanDialogFormAssignToComponent } from '../../components/dialog-form-assign-to/annual-plan-dialog-form-assign-to.component';
import { Title } from '@angular/platform-browser';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { BreadcrumbProvider, Crumb } from '../../../breadcrumb/providers/breadcrumb-provider';
import { AnnualPlanRights } from '../../providers/annual-plan-rights';
import { forkJoin, Subscription, switchMap, tap } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnnualPlan } from "../../../common/models/annual-plan";
import { ModuleMenu } from "../../../common/models/menu";
import { SimpleMatDataSource } from "../../../common/providers/simple-mat-data-source";
import { Organization } from "../../../common/models/organization";
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { ConfirmDialogComponent } from "../../../common/components/confirm-dialog/confirm-dialog";
import { LibraryService } from "../../../libraries/providers/library.services";
import { Library } from "../../../common/models/library";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { Error404Component } from "../../../common/components/error-404/error-404";
import { LibrariesSideMenuComponent } from "../../../libraries/components/side-menu/side-menu";
import { MatFormField } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable
} from "@angular/material/table";
import { NgIf } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { MatInput } from "@angular/material/input";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { map } from "rxjs/operators";
import { Athlete } from "../../../common/models/athlete";
import { AthleteCoach } from "../../../common/models/athlete-coach";
import { Coach } from "../../../common/models/coach";
import { AthletesProvider } from "../../../athletes/providers/athletes-provider";
import { OrganizationsProvider } from "../../../organizations/providers/organizations-provider";
import { UsersProvider } from "../../../users/providers/users-provider";
import { ExercicesProvider } from "../../../exercices/providers/exercices-provider";
import { User } from "../../../common/models/user";

@Component({
  selector: 'app-annual-plan-library',
  templateUrl: './annual-plan-library.component.html',
  styleUrls: ['./annual-plan-library.scss'],
  imports: [
    MatPaginator,
    HeaderComponent,
    Error401Component,
    PageContentComponent,
    ModuleContentComponent,
    SideMenuComponent,
    Error404Component,
    LibrariesSideMenuComponent,
    MatFormField,
    MatIcon,
    MatMenu,
    MatCell,
    MatHeaderCell,
    MatHeaderRow,
    MatTable,
    MatRow,
    TranslateModule,
    MatCellDef,
    MatMenuItem,
    MatColumnDef,
    NgIf,
    MatIconButton,
    MatHeaderRowDef,
    MatRowDef,
    MatMenuTrigger,
    MatHeaderCellDef,
    MatInput,
    MatSortModule,
  ],
  standalone: true
})
export class AnnualPlanLibraryComponent implements OnInit, AfterViewInit, OnDestroy {

    public pageTitle = '';
    public isLoading = true;
    public is401 = false;
    public is404 = false;
    public annualPlan: AnnualPlan = {} as AnnualPlan;

    public mainActions: ModuleMenu[] = [];
    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    public columns: string[] = ['title', 'creator', 'action'];

    public organization: Organization = {} as Organization;

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | null = null;
    private library: Library = {} as Library;
    private annualPlanRights: AnnualPlanRights = new AnnualPlanRights(this.utils);
    private _displayContext = 0;
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        public breadcrumbProvider: BreadcrumbProvider,
        private currentUser: CurrentUser,
        private route: ActivatedRoute,
        private annualPlanService: AnnualPlanService,
        private router: Router,
        private utils: UtilsProvider,
        private translator: TranslateService,
        private dialog: MatDialog,
        private toaster: MatSnackBar,
        private _title: Title,
        private currentUserRoles: CurrentUserRolesProvider,
        private organizationsProvider: OrganizationsProvider,
        private execicesProvider: ExercicesProvider,
        private athletesProvider: AthletesProvider,
        private usersProvider: UsersProvider,
    ) {
    }

    public ngOnInit() {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { // { organization: Organization; library: Library; context: number }

                if (data.organization) {
                    this.organization = data.organization;
                }
                if (!this.organization.id) return;

                this.annualPlanRights.evaluateScreenRights({
                    rolesIds: this.currentUserRoles.getRolesIds(this.organization.id)
                });
                if (!this.annualPlanRights.LIST) {
                    this.is401 = true;
                    return;
                }

                if (data.library) {
                    this.library = data.library;
                }

                this.getAllAnnualPlans();

                this.dataSource.filterPredicate = (row: AnnualPlanRow, filter: string) => {
                    const subject: string = this.utils.normalizeString(row.title +
                        row.creator?.firstName + ' ' + row.creator?.lastName
                    );
                    const filters: string[] = filter.split(' ');

                    for (let i = 0; i < filters.length; i++) {
                        if (!subject.includes(filters[i])) {
                            return false;
                        }
                    }

                    return true;
                };

                if (this.annualPlanRights.ADD) {
                    this.mainActions = [
                        {title: 'Add', icon: 'add', url: null, onClick: () => this.onAddClicked()}
                    ];
                }

                this.createPageTitle(data);
                this.createBreadcrumb();
                this.isLoading = false;
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public ngAfterViewInit() {
        this.initSorters();
        this.initNav();
    }

    public onSortChange(event: any): void {
        this.dataSource.sortBy(event.active, event.direction);
    }

    public onAddClicked(): void {
        const dialogRef: any = this.dialog.open(AnnualPlanFormComponent, {
            data: {
                formTitle: 'AnnualPlan_New',
                formSaveActionTitle: 'Save',
                organization: this.organization,
                library: this.library,
            }
        });

        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
                if (row) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Added'), '', {duration: 5000});
                }
            })
        );
    }

    public onEditClicked(toModify: AnnualPlanRow) {
        const dialogRef: any = this.dialog.open(AnnualPlanFormComponent, {
            data: {
                formTitle: 'AnnualPlan_Edit',
                formSaveActionTitle: 'Save',
                annualPlanRow: toModify,
                organization: this.organization,
                isLangSelectable: true
            }
        });

        // Update the list by fetching all objects after dialog closed
        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((annualPlan: any) => {
                if (annualPlan) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Edited'), '', {duration: 5000});
                }
            })
        );
    }

    public onDuplicateClicked(toDuplicate: AnnualPlanRow) {
        toDuplicate = JSON.parse(JSON.stringify(toDuplicate)); // clone object
        toDuplicate.title = toDuplicate.title + ' (1)';

        const dialogRef: any = this.dialog.open(AnnualPlanFormComponent, {
            data: {
                formTitle: 'AnnualPlan_Duplicate',
                formSaveActionTitle: 'Duplicate',
                annualPlanRow: toDuplicate,
                organization: this.organization,
                library: this.library,
                toDuplicate: true,
                skipLangSelection: true
            }
        });

        // Update the list by fetching all objects after dialog closed
        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
                if (row) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Duplicated'), '', {duration: 5000});
                }
            })
        );
    }

    public onDeleteClicked(plan: AnnualPlan) {
        const dialog: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
            data: {
                confirmText: 'AnnualPlanConfirmDeleteMembership',
                confirmActionText: 'Delete',
                confirmColor: 'primary'
            }
        });
        this.subscriptions.push(
            dialog.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.annualPlanService.remove(this.organization, plan).subscribe((result) => {
                        this.getAllAnnualPlans();
                        this.toaster.open(this.translator.instant('AnnualPlan_Deleted'), '', {duration: 5000});
                    }, (err) => {
                        this.toaster.open(err.error.message, '', {duration: 5000});
                    });
                }
            })
        );
    }

    public onAssignToClicked(annualPlanRow: AnnualPlanRow) {
        const dialogRef: any = this.dialog.open(AnnualPlanDialogFormAssignToComponent, {
            data: {
                dialogTitle: 'AnnualPlan_AssignTo',
                annualPlanRow,
                organization: this.organization,
                library: this.library,
                toDuplicate: true,
            }
        });

        // Update the list by fetching all objects after dialog closed
        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
                if (row) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Assigned'), '', {duration: 5000});
                }
            })
        );
    }

    public onFilterKeyup(filter: string): void {
        this.dataSource.filter = this.utils.normalizeString(filter);
    }

    public onRowClicked(row: AnnualPlanRow): void {
        const currentPath = this.router.url;
        let url: string | null = null;

        if (currentPath.includes('plans-elitment')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans-elitment/' + row.id;
        } else if (currentPath.includes('plans-super-coach')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans-super-coach/' + row.id;
        } else if (currentPath.includes('plans/personal')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans/personal/' + row.id;
        } else {
            // Default to personal plans
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans/personal/' + row.id;
        }
        this.router.navigateByUrl(url);
    }

    private updateAnnualPlan(...values: Object[]) {
        Object.assign(this.annualPlan, ...values);
    }

    private initNav(): void {
        this.dataSource.paginator = this.paginator!;
        this.route.data.subscribe((data:any) => {
            if (data.context === LibraryService.CONTEXT_USER) {
                this._displayContext = LibraryService.CONTEXT_USER;
            } else {
                this._displayContext = LibraryService.CONTEXT_ORGANIZATION;
            }
        });
    }

    private initSorters(): void {
        this.dataSource.addSortDefinition(
            'title',
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow(a.title.toLowerCase(), b.title.toLowerCase()),
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow(b.title.toLowerCase(), a.title.toLowerCase())
        );

        this.dataSource.addSortDefinition(
            'creator',
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow((`${a.creator.firstName} ${a.creator.lastName}`).toLowerCase(), (`${b.creator.firstName} ${b.creator.lastName}`).toLowerCase()),
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow((`${b.creator.firstName} ${b.creator.lastName}`).toLowerCase(), (`${a.creator.firstName} ${a.creator.lastName}`).toLowerCase())
        );
    }

    private createPageTitle(data:any) {
        const filterKey = this.route.snapshot.routeConfig?.path?.split('/').pop();

        if (filterKey === 'personal') {
            this.pageTitle = this.translator.instant('Personal_annual_plans_title');
        } else if (filterKey === 'plans-elitment') {
            this.pageTitle = this.translator.instant('Elitment_annual_plans_title');
        } else if (filterKey === 'plans-super-coach') {
            this.pageTitle = this.translator.instant('Super_coaches_annual_plans_title');
        } else {
            // Default fallback
            if (data.context === LibraryService.CONTEXT_USER) {
                this.pageTitle = this.translator.instant('Personal_annual_plans_title');
            } else {
                this.pageTitle = this.translator.instant('Organization_plans', {organization: this.organization.name});
            }
        }
        this._title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }

    private createBreadcrumb() {

        const crumbs: Crumb[] = [
            {
                shortTitle: 'Annual_plans',
                title: this.pageTitle,
                url: this.router.url
            }
        ];
        this.breadcrumbProvider.setDefaultCrumbs(crumbs);
    }

    private getAllAnnualPlans() {
        const filterKey = this.route.snapshot.routeConfig?.path?.split('/').pop()

        this.subscriptions.push(
            this.annualPlanService.findAllByLibrary(this.organization, this.library, filterKey).pipe(
              switchMap((plans: AnnualPlan[]) => {
                return this.usersProvider.getUsers(this.organization.id!).pipe(
                  map((users) => {
                    const annualPlanRows: AnnualPlanRow[] = [];
                    if (plans.length > 0) {
                      plans.forEach((plan) => {

                        this.annualPlanRights.evaluateItemRight(plan.rights);

                        annualPlanRows.push({
                          id: plan.id!,
                          title: plan.title!,
                          athleteId: plan.athleteId!,
                          libraryId: plan.libraryId!,
                          weeklyWorkingTime: plan.weeklyWorkingTime,
                          availableLangIds: plan.availableLangIds,
                          weeksLength: plan.weeksLength,
                          comment: plan.comment,
                          creator: new User({id: plan.createrId, firstName: plan.firstName, lastName: plan.lastName}),
                          rights: this.annualPlanRights.getItemRightsList(),
                        });
                      });
                    }
                    // Filter by currentUser if in user context
                    const filteredRows = this._displayContext === LibraryService.CONTEXT_USER
                      ? annualPlanRows.filter((row: AnnualPlanRow) => row.creator?.id === this.currentUser.user?.id)
                      : annualPlanRows;
                    this.dataSource.replaceAllWith(filteredRows);
                  }),
                );
              })
            ).subscribe()
        );
    }
}
